module.exports = __webpack_public_path__ + "img/earth.4fb831c6.png";